import React from 'react';
import {useFormik} from "formik";

import {useAuthentication} from "../../Auth";
import {useFeedbackTools} from "../../components/FeedbackTools";
import PasswordField from "../../components/PasswordField";

import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Switch from "@mui/material/Switch";
import Typography from '@mui/material/Typography';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";


const LoginPage = () => {
    const {login} = useAuthentication();
    const {showErrorNotification} = useFeedbackTools();

    const [isLoading, setIsLoading] = React.useState(false);
    const [state, setError] = React.useState({
        apiError: null,
        loginAttempts: 0,
        showForgotPasswordAlert: false
    });

    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
            remember: true,
        },
        onSubmit: async (values) => {
            setIsLoading(true);
            const {email, password, remember} = values;
            try {
                await login(email, password, remember);
            } catch (e) {
                if (e.httpStatus === 401) {
                    const attempts = state.loginAttempts + 1;
                    setError({
                        apiError: e,
                        loginAttempts: attempts,
                        showForgotPasswordAlert: attempts % 3 === 0,
                    });
                } else {
                    showErrorNotification(e);
                }
                setIsLoading(false);
            }
        },
    });

    const handleCloseForgotPasswordAlert = () => {
        setError({...state, showForgotPasswordAlert: false});
    };

    return (
        <React.Fragment>
            {
                state.apiError &&
                <Typography component="div" variant="body1">
                    <Box sx={{color: 'error.main'}}>{state.apiError.title}</Box>
                </Typography>
            }

            <Box component="form"
                 noValidate
                 onSubmit={formik.handleSubmit}
                 sx={{mt: 1, width: "100%"}}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Email Address"
                    name="email"
                    autoComplete="username"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    error={!!state.apiError}/>

                <PasswordField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    autoComplete="current-password"
                    onChange={formik.handleChange}
                    value={formik.values.password}
                    error={!!state.apiError}/>

                <Box sx={{mt: 1}}>
                    <FormControlLabel
                        control={
                            <Switch
                                value="Ricordami"
                                name="remember"
                                color="primary"
                                onChange={formik.handleChange}
                                checked={formik.values.remember}
                            />}
                        label="Ricordami"/>
                </Box>

                <LoadingButton
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{my: 3}}
                    loading={isLoading}>
                    Accedi
                </LoadingButton>

                <Box textAlign="center">
                    <Link component={RouterLink} to="/auth/password-reset">
                        Password Dimenticata?
                    </Link>
                </Box>
            </Box>

            <Dialog
                open={state.showForgotPasswordAlert}
                onClose={handleCloseForgotPasswordAlert}>
                <DialogTitle>
                    Non ricordi la password?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Se ti sei dimenticato la password puoi impostarne una nuova premendo
                        il tasto <b>Password Dimenticata?</b> che trovi sotto il pulsante per accedere.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseForgotPasswordAlert} autoFocus>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default LoginPage;